import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessPayedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 126,
	height: 151,
	viewBox: "0 0 126 151",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1131_31518)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M119.488 62.3723L12.4774 0.568368C11.3136 -0.108708 10.2448 -0.156221 9.42542 0.295162L6.21901 2.12445L6.12402 2.55208L7.77471 3.33606C7.75095 3.59739 7.72723 3.87059 7.72723 4.15568V77.7312C7.72723 81.2235 9.85295 85.2859 12.4774 86.8064L119.488 148.61C119.642 148.705 119.809 148.788 119.963 148.848L119.274 149.157L119.393 150.689L122.504 148.919C123.561 148.373 124.238 146.995 124.238 145.035V71.4593C124.238 67.9671 122.112 63.9046 119.488 62.3842V62.3723Z",
				fill: "#E06E41"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M116.294 150.428L9.28342 88.6238C6.65893 87.1152 4.5332 83.0527 4.5332 79.5486V5.97307C4.5332 2.48079 6.65893 0.86531 9.28342 2.38576L116.294 64.1897C118.918 65.6982 121.044 69.7607 121.044 73.2649V146.84C121.044 150.333 118.918 151.948 116.294 150.428Z",
				fill: "#EDA25D"
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .5,
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M17.5848 60.5668L14.699 58.9038C14.2953 58.6662 13.9746 58.0485 13.9746 57.514V52.4656C13.9746 51.9311 14.2953 51.6816 14.699 51.9192L17.5848 53.5822C17.9886 53.8198 18.3092 54.4374 18.3092 54.972V60.0203C18.3092 60.5549 17.9767 60.8043 17.5848 60.5668Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M22.5965 63.4525L19.7108 61.7895C19.307 61.5519 18.9863 60.9343 18.9863 60.3997V55.3513C18.9863 54.8168 19.3189 54.5674 19.7108 54.8049L22.5965 56.4679C23.0003 56.7055 23.3209 57.3232 23.3209 57.8577V62.9061C23.3209 63.4406 22.9884 63.6901 22.5965 63.4525Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M27.5955 66.3519L24.7097 64.6889C24.306 64.4513 23.9854 63.8337 23.9854 63.2991V58.2508C23.9854 57.7162 24.3178 57.4668 24.7097 57.7044L27.5955 59.3673C27.9993 59.6049 28.3199 60.2226 28.3199 60.7571V65.8055C28.3199 66.34 27.9874 66.5895 27.5955 66.3519Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M32.5955 69.2377L29.7097 67.5747C29.306 67.3371 28.9854 66.7194 28.9854 66.1849V61.1365C28.9854 60.602 29.3178 60.3525 29.7097 60.5901L32.5955 62.2531C32.9993 62.4907 33.3199 63.1083 33.3199 63.6429V68.6912C33.3199 69.2258 32.9874 69.4752 32.5955 69.2377Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M42.1903 74.7855L39.3045 73.1225C38.9007 72.8849 38.5801 72.2673 38.5801 71.7327V66.6844C38.5801 66.1498 38.9126 65.9004 39.3045 66.1379L42.1903 67.8009C42.594 68.0385 42.9146 68.6562 42.9146 69.1907V74.2391C42.9146 74.7736 42.594 75.0231 42.1903 74.7855Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M47.1892 77.6722L44.3035 76.0092C43.8997 75.7717 43.5791 75.154 43.5791 74.6194V69.5711C43.5791 69.0365 43.9116 68.7871 44.3035 69.0247L47.1892 70.6877C47.593 70.9252 47.9137 71.5429 47.9137 72.0774V77.1258C47.9137 77.6603 47.5811 77.9098 47.1892 77.6722Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M52.201 80.558L49.3152 78.895C48.9114 78.6574 48.5908 78.0397 48.5908 77.5052V72.4568C48.5908 71.9223 48.9233 71.6728 49.3152 71.9104L52.201 73.5734C52.6047 73.811 52.9254 74.4287 52.9254 74.9632V80.0116C52.9254 80.5461 52.5929 80.7955 52.201 80.558Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M57.201 83.4447L54.3152 81.7817C53.9114 81.5441 53.5908 80.9264 53.5908 80.3919V75.3435C53.5908 74.809 53.9233 74.5596 54.3152 74.7971L57.201 76.4601C57.6048 76.6977 57.9254 77.3154 57.9254 77.8499V82.8983C57.9254 83.4328 57.5929 83.6823 57.201 83.4447Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M66.7967 88.9916L63.911 87.3286C63.5072 87.091 63.1865 86.4733 63.1865 85.9388V80.8904C63.1865 80.3559 63.5191 80.1064 63.911 80.344L66.7967 82.007C67.2005 82.2446 67.5211 82.8622 67.5211 83.3968V88.4451C67.5211 88.9797 67.1886 89.2291 66.7967 88.9916Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M71.7967 91.8773L68.9109 90.2143C68.5071 89.9767 68.1865 89.3591 68.1865 88.8245V83.7762C68.1865 83.2416 68.519 82.9922 68.9109 83.2297L71.7967 84.8927C72.2004 85.1303 72.5211 85.748 72.5211 86.2825V91.3309C72.5211 91.8654 72.1886 92.1149 71.7967 91.8773Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M76.7957 94.764L73.9099 93.101C73.5062 92.8635 73.1855 92.2458 73.1855 91.7112V86.6629C73.1855 86.1283 73.518 85.8789 73.9099 86.1165L76.7957 87.7795C77.1995 88.017 77.5201 88.6347 77.5201 89.1692V94.2176C77.5201 94.7521 77.1876 95.0016 76.7957 94.764Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M81.8074 97.6507L78.9217 95.9878C78.5179 95.7502 78.1973 95.1325 78.1973 94.598V89.5496C78.1973 89.0151 78.5298 88.7656 78.9217 89.0032L81.8074 90.6662C82.2112 90.9037 82.5318 91.5214 82.5318 92.056V97.1043C82.5318 97.6389 82.1993 97.8883 81.8074 97.6507Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M91.4022 103.199L88.5164 101.536C88.1127 101.298 87.792 100.68 87.792 100.146V95.0974C87.792 94.5629 88.1245 94.3135 88.5164 94.551L91.4022 96.214C91.8059 96.4516 92.1266 97.0693 92.1266 97.6038V102.652C92.1266 103.187 91.7941 103.436 91.4022 103.199Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M96.4022 106.085L93.5164 104.422C93.1127 104.185 92.792 103.567 92.792 103.033V97.9842C92.792 97.4496 93.1245 97.2002 93.5164 97.4378L96.4022 99.1007C96.8059 99.3383 97.1266 99.956 97.1266 100.491V105.539C97.1266 106.073 96.7941 106.323 96.4022 106.085Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M101.401 108.971L98.5154 107.308C98.1116 107.07 97.791 106.453 97.791 105.918V100.87C97.791 100.335 98.1235 100.086 98.5154 100.323L101.401 101.986C101.805 102.224 102.126 102.842 102.126 103.376V108.425C102.126 108.959 101.793 109.209 101.401 108.971Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M106.401 111.858L103.515 110.195C103.112 109.957 102.791 109.34 102.791 108.805V103.757C102.791 103.222 103.124 102.973 103.515 103.21L106.401 104.873C106.805 105.111 107.126 105.728 107.126 106.263V111.311C107.126 111.846 106.793 112.095 106.401 111.858Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M23.7838 84.3472L14.2002 78.8118C13.8677 78.6217 13.6064 78.111 13.6064 77.6833V75.6996C13.6064 75.2601 13.8677 75.0582 14.2002 75.2482L23.7838 80.7836C24.1163 80.9737 24.3776 81.4845 24.3776 81.9121V83.8958C24.3776 84.3353 24.1163 84.5372 23.7838 84.3472Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M39.9226 93.6598L25.6719 85.428C25.3394 85.238 25.0781 84.7272 25.0781 84.2996V82.3158C25.0781 81.8763 25.3394 81.6744 25.6719 81.8645L39.9226 90.0963C40.2551 90.2863 40.5163 90.7971 40.5163 91.2247V93.2084C40.5163 93.6479 40.2551 93.8499 39.9226 93.6598Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M23.7838 25.3472L14.2002 19.8118C13.8677 19.6217 13.6064 19.111 13.6064 18.6833V13.433C13.6064 12.9935 13.8677 12.7916 14.2002 12.9816L23.7838 18.517C24.1163 18.7071 24.3776 19.2179 24.3776 19.6455V24.8958C24.3776 25.3353 24.1163 25.5372 23.7838 25.3472Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M39.9226 34.6725L25.6719 26.4407C25.3394 26.2506 25.0781 25.7399 25.0781 25.3122V20.0619C25.0781 19.6224 25.3394 19.4205 25.6719 19.6105L39.9226 27.8424C40.2551 28.0324 40.5163 28.5432 40.5163 28.9708V34.2211C40.5163 34.6606 40.2551 34.8626 39.9226 34.6725Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M57.8425 96.0841L55.3243 94.6349C55.158 94.5399 55.0273 94.2904 55.0273 94.0766V89.7409C55.0273 89.5271 55.158 89.4321 55.3243 89.5153L57.8425 90.9644C58.0088 91.0594 58.1395 91.3089 58.1395 91.5227V95.8584C58.1395 96.0722 58.0088 96.1672 57.8425 96.0841Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M61.3934 98.1505L58.8751 96.7013C58.7088 96.6063 58.5781 96.3568 58.5781 96.143V91.8074C58.5781 91.5935 58.7088 91.4985 58.8751 91.5817L61.3934 93.0308C61.5597 93.1259 61.6903 93.3753 61.6903 93.5891V97.9248C61.6903 98.1386 61.5597 98.2336 61.3934 98.1505Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M68.3172 102.143L65.7989 100.693C65.6326 100.598 65.502 100.349 65.502 100.135V95.7995C65.502 95.5857 65.6326 95.4907 65.7989 95.5738L68.3172 97.023C68.4835 97.1181 68.6141 97.3675 68.6141 97.5813V101.917C68.6141 102.131 68.4835 102.226 68.3172 102.143Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M71.8797 104.197L69.3614 102.748C69.1951 102.653 69.0645 102.404 69.0645 102.19V97.8542C69.0645 97.6404 69.1951 97.5454 69.3614 97.6285L71.8797 99.0777C72.046 99.1727 72.1766 99.4222 72.1766 99.636V103.972C72.1766 104.185 72.046 104.281 71.8797 104.197Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M62.5091 98.5418C62.3666 98.3636 62.3191 98.1379 62.4022 98.0191L64.3384 95.287C64.4216 95.1682 64.5998 95.2158 64.7423 95.394C64.8849 95.5721 64.9324 95.7978 64.8492 95.9166L62.913 98.6487C62.8299 98.7674 62.6517 98.7199 62.5091 98.5418Z",
						fill: "white"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81.6738 37.82L86.3409 35.1117C90.4973 32.6885 96.2689 33.0329 102.622 36.7034L97.9552 39.4117C91.5899 35.7412 85.8303 35.3968 81.6738 37.82Z",
				fill: "#BCC0CD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M118.762 90.9175L114.095 93.6258C118.204 91.2382 120.757 86.1542 120.769 78.9439C120.805 64.4165 110.592 46.7175 97.9561 39.4241L102.623 36.7158C115.259 44.0092 125.484 61.7201 125.436 76.2356C125.412 83.4578 122.871 88.5299 118.762 90.9175Z",
				fill: "#BCC0CD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M97.9675 39.4114C110.603 46.7048 120.828 64.4157 120.78 78.9312C120.745 93.4586 110.461 99.3147 97.8131 92.0213C85.1775 84.7279 74.9527 67.0171 75.0002 52.5015C75.0358 37.9741 85.32 32.118 97.9675 39.4114Z",
				fill: "#E5E7EE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M91.4241 78.6001L88.0515 72.7916C87.2914 71.4849 87.2914 70.0833 88.0515 69.6556L109.451 57.4564C110.211 57.0288 111.434 57.7296 112.183 59.0362L115.555 64.8448C116.315 66.1515 116.315 67.5531 115.555 67.9808L94.1555 80.18C93.3955 80.6076 92.1723 79.9068 91.4241 78.6001Z",
				fill: "#61BB79"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M97.5159 78.2558L94.1433 80.1802C93.3832 80.6078 92.16 79.907 91.4119 78.6003L80.237 59.3096C79.477 58.003 79.477 56.6013 80.237 56.1737L83.6097 54.2494C84.3697 53.8217 85.5929 54.5226 86.341 55.8292L97.5159 75.1199C98.276 76.4266 98.276 77.8282 97.5159 78.2558Z",
				fill: "#61BB79"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1131_31518",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 126,
			height: 151,
			fill: "white"
		})
	}) })]
});
export default SvgSuccessPayedIcon;
